import { inject, type InjectionKey } from 'vue'
import type { OperacoesCatalogoPerfilDePermissao } from '../catalogo-perfil-de-permissao.tipos'
export const CHAVE_OPERACOES_CATALOGO_PERFIL_DE_PERMISSAO:
InjectionKey<OperacoesCatalogoPerfilDePermissao> = Symbol('operacoes-catalogo-perfil-de-permissao')
export const usarOperacoesCatalogoPerfilDePermissao = (): OperacoesCatalogoPerfilDePermissao => {
  const operacoes = inject(CHAVE_OPERACOES_CATALOGO_PERFIL_DE_PERMISSAO)
  if (!operacoes) throw new Error('Catalogo de perfil de permissao nao foi instalado')
  return operacoes
}
